import React, { Component } from 'react';
import {Button, List, WingBlank, Stepper, InputItem, WhiteSpace} from 'antd-mobile';
import Mask from '../components/mask'
import Bubble from '../components/bubble'
import InputNumber from '../../../components/InputNumber';
import auth from '../../../utils/auth'

export default class Loc extends Component {
  constructor (props) {
    super(props);
    this.state = {
      farmType: 'SW',// 不同类型的农场，初始化不同的栋舍数量。提示信息位置相应改变。
      mask: false,
      loc1: 0,//配种舍
      loc2: 0, // 分娩舍
      loc3: 0, // 保育舍
      loc4: 0, // 育成
      loc5: 0, // 选种
      loc6: 0, // 后备舍
      loc1Names: [],
      loc2Names: [],
      loc3Names: [],
      loc4Names: [],
      loc5Names: [],
      loc6Names: [],
      tooltips: [
        {
          message: '请根据您实际的栋舍数量进行添加和删除',
          position: {
            top: 45
          },
          visible: false
        },
        {
          message: '系统会自动生成栋舍的名称，如果您想修改点击“灰色字”就可以修改您想要的名称啦！',
          position: {
            top: 90
          },
          visible: false
        }
      ]
    }
  }
  componentWillUnmount() {
    this.setState = () => false
  }
  componentDidMount() {
    const {farmType} = auth.readCookie('farm');
    this.setState({farmType});
    this.renderAdd()
  }
  renderAdd = () => {
    let loc = auth.readCookie('loc');
    if (loc) {
      // 读取用户修改后的数据。
      this.setState({
        ...loc
      });
    } else {
      // 初始数据
      const {farmType} = auth.readCookie('farm') || {};
      if (farmType === 'SW'){
        // 种猪场 后备1，配种1，育成1
        this.setState({
          loc1: 1,
          loc2:1,
          loc6:1,
          loc1Names: [
            {
              houseName:'配种舍', // 舍名
              locName: '01', // 栋名
              name: '配种舍01栋',
              num: ''
            }
          ],
          loc2Names: [
            {
              houseName:'分娩舍', // 舍名
              locName: '01', // 栋名
              name: '分娩舍01栋',
              num: ''
            }
          ],
          loc6Names: [
            {
              houseName:'后备舍', // 舍名
              locName: '01', // 栋名
              name: '后备舍01栋',
              num: 1
            }
          ]
        })
      } else if (farmType === 'PG') {
        //  肥猪场
        this.setState({
          loc3:1,
          loc4:1,
          loc3Names: [
            {
              houseName:'保育舍', // 舍名
              locName: '01', // 栋名
              name: '保育舍01栋',
              num: 0,
              batchNum: 1,
              batchNames: [{name: '001'}]
            }
          ],
          loc4Names: [
            {
              houseName:'育成舍', // 舍名
              locName: '01', // 栋名
              name: '育成舍01栋',
              num: 0,
              batchNum: 1,
              batchNames: [{name: '001'}]
            }
          ],
          tooltips: [
            {
              message: '请根据您实际的栋舍数量进行添加和删除',
              position: {
                top: 240
              },
              visible: false
            },
            {
              message: '系统会自动生成栋舍的名称，如果您想修改点击“灰色字”就可以修改您想要的名称啦！',
              position: {
                top: 290
              },
              visible: false
            }
          ]
        })
      }
      this.setState(state => {
        state.mask = auth.readCookie('ISFIRST') || 'false';
        state.tooltips[0].visible = auth.readCookie('ISFIRST') || 'false';
        return state;
      })
    }

  };
  doSave = () => {
    // 存入本地数据
    this.setData();
    this.props.history.replace('/createfarm/batch_add');
    auth.setCookie('path', '/createfarm/batch_add');
  };
  setData = () => {
    const {
        loc1,//配种舍
        loc2, // 分娩舍
        loc3, // 保育舍
        loc4, // 育成
        loc5, // 选种
        loc6, // 后备舍
        loc1Names,
        loc2Names,
        loc3Names,
        loc4Names,
        loc5Names,
        loc6Names
    } = this.state;
    auth.setCookie('loc', {
      loc1,//配种舍
      loc2, // 分娩舍
      loc3, // 保育舍
      loc4, // 育成
      loc5, // 选种
      loc6, // 后备舍
      loc1Names,
      loc2Names,
      loc3Names,
      loc4Names,
      loc5Names,
      loc6Names
    })
  };
 render() {
   const {farmType,loc1, loc2, loc3, loc4, loc6, mask, tooltips, loc1Names, loc2Names, loc3Names, loc4Names, loc6Names} = this.state;
  return (
    <React.Fragment>
      {/*配种1*/}
      {/*{auth.readCookie('ORGCODE') + auth.readCookie('FARMORG')}*/}
      {/*{JSON.stringify(loc4Names)} {loc4}*/}
      {/*{farmType}*/}
      {/*<div style={{fontSize: 16}}>*/}
        {/*{JSON.stringify(loc4Names)}*/}
      {/*</div>*/}
      <List>
        <List.Item
            className={(tooltips[0].visible && farmType==='SW')?'topShow w-10': ''}
            style={{height: 46}}
            extra={
            <Stepper
                className={'stepper-round'}
                style={{ width: '100%', minWidth: '100px' }}
                showNumber
                min={0}
                max={10}
                value={loc1}
                onChange={v => {
                  let num = parseInt(Number(v));
                  if (num > 10){num = 10}
                  let locNames = new Array(num).fill('').map((o,index) => {
                    let houseName = '配种舍';
                    let currentName = `${o}${index >= 9 ? index : ('0' + (index + 1))}`;
                    let currentNum = '';
                    if (loc1Names[index]) {
                      currentName = loc1Names[index].locName;
                      currentNum = loc1Names[index].num
                    }
                    return {
                      houseName,
                      locName: currentName,
                      name: houseName + currentName + '栋',//栋名
                      num: currentNum
                    }
                  });
                  this.setState({
                    loc1: num,
                    loc1Names: locNames
                }, () => {
                  this.setData()
                })
              }}
            />
            }
        >
          配种舍
        </List.Item>
        {
          loc1Names.map((o, index) => {
            return <div key={'loc1' + index}>
              <InputItem
                  maxLength={10}
                  labelNumber={6}
                  type={'text'}
                  extra={'栋'}
                  className={(tooltips[1].visible && index === 0 && farmType==='SW')?'topShow w-10 no-border text-right': ' no-border text-right'}
                  placeholder={o.locName}
                  onChange={v => {
                    this.setState(state => {
                      state.loc1Names[index].locName = v;
                      state.loc1Names[index].name = `配种舍${v}栋`;
                      return state
                    }, () => {
                      this.setData()
                    })
                  }}
              >
                栋舍名称({`${index + 1}`})
              </InputItem>
              {
                // 因为后台与泰国系统的字段没对上，所以暂时存不上。
                false &&
                <InputNumber
                    precision={0}
                    pattern="[0-9]*"
                    min={1}
                    max={99}
                    value={o.num}
                    className={'text-right  no-border'}
                    placeholder={'填写数量'}
                    onChange={v => {
                    this.setState(state => {
                      state.loc1Names[index].num = v;
                      return state
                    }, () => {
                      this.setData()
                    })
                  }}
                >
                  定位栏数量
                </InputNumber>
              }
            </div>
          })
        }
      </List>
      {/*分娩2*/}
      <List renderHeader={() => ''}>
        <List.Item
            extra={
            <Stepper
                className={'stepper-round'}
                style={{ width: '100%', minWidth: '100px' }}
                showNumber
                min={0}
                max={10}
                value={loc2}
                onChange={v => {
                  let num = parseInt(Number(v));
                  const houseName = '分娩舍';
                  let locNames = new Array(num).fill('分娩舍').map((o,index) => {
                    let currentName = `${index >= 9 ? index : ('0' + (index + 1))}`;
                    let currentNum = '';
                    if (loc1Names[index]) {
                      currentName = loc1Names[index].locName;
                      currentNum = loc1Names[index].num
                    }
                    return {
                      houseName,
                      locName: currentName,
                      name: houseName + currentName + '栋',//栋名
                      num: currentNum
                    }
                  });
                  this.setState({
                    loc2: num,
                    loc2Names: locNames
                  }, () => {
                    this.setData()
                  })
              }}
            />}
        >
          分娩舍
        </List.Item>
        {
          loc2Names.map((o, index) => {
            return <div key={'loc2' + index}>
              <InputItem
                  maxLength={10}
                  labelNumber={6}
                  type={'text'}
                  extra={'栋'}
                  className={' no-border text-right'}
                  placeholder={o.locName}
                  onChange={v => {
                    this.setState(state => {
                      state.loc2Names[index].locName = v;
                      state.loc2Names[index].name = `分娩舍${v}栋`;
                      return state
                    }, () => {
                      this.setData()
                    })
                  }}
              >
                栋舍名称({`${index + 1}`})
              </InputItem>
              {
                // 因为后台与泰国系统的字段没对上，所以暂时存不上。
                false &&
                <InputNumber
                    value={o.num || ''}
                    precision={0}
                    pattern="[0-9]*"
                    className={'text-right  no-border'}
                    placeholder={'填写数量'}
                    onChange={v => {
                    this.setState(state => {
                      state.loc2Names[index].num = Number(v);
                      return state
                    }, () => {
                      this.setData()
                    })
                  }}
                >
                产房数
              </InputNumber>}
            </div>
          })
        }
      </List>
      {/*后备6*/}
      <List renderHeader={() => ''}>
        <List.Item
            extra={
            <Stepper
                className={'stepper-round'}
                style={{ width: '100%', minWidth: '100px' }}
                showNumber
                min={0}
                max={10}
                value={loc6}
                onChange={v => {
                  let num = parseInt(Number(v));
                  let locNames = new Array(num).fill('后备舍').map((o,index) => {
                    let currentName = `${index >= 9 ? index : ('0' + (index + 1))}`;
                    if (loc6Names[index]) {
                      currentName = loc6Names[index].locName
                    }
                    return {
                      houseName:o,
                      locName: currentName,
                      name: o + currentName + '栋',
                      num: 1
                    }
                  });
                  this.setState({
                    loc6: num,
                    loc6Names: locNames
                  }, () => {
                    this.setData()
                  })
              }}
            />}
        >
          后备舍
        </List.Item>
        {
          loc6Names.map((o, index) => {
            return <InputItem
                extra={'栋'}
                labelNumber={6}
                maxLength={10}
                type={'text'}
                className={'no-border text-right'}
                key={'loc6' + index}
                placeholder={o.locName}
                onChange={v => {
                  this.setState(state => {
                    state.loc6Names[index].locName = v;
                    state.loc6Names[index].name = `后备舍${v}栋`;
                    return state
                  }, () => {
                    this.setData()
                  })
                }}
                   >
              栋舍名称({`${index + 1}`})
            </InputItem>
          })
        }
      </List>
      {/*保育3*/}

      <List renderHeader={() => ''}>
        <List.Item
            className={(tooltips[0].visible && farmType==='PG')?'topShow w-10': ''}
            extra={
            <Stepper
                className={'stepper-round'}
                style={{ width: '100%', minWidth: '100px' }}
                showNumber
                min={0}
                max={10}
                value={loc3}
                onChange={v => {
                  let num = parseInt(Number(v));
                  let locNames = new Array(num).fill('保育舍').map((o,index) => {
                    let currentName = `${index >= 9 ? index : ('0' + (index + 1))}`;
                    if (loc3Names[index]) {
                      let name = loc3Names[index].locName;
                      currentName = (currentName !== name) ? name : currentName
                    }
                    return {
                      houseName: o,
                      locName: currentName,
                      name: o + currentName + '栋',
                      num: num,
                      batchNum: 1,
                      batchNames: [{
                        name: '001'
                      }]
                    }
                  });
                  this.setState({
                    loc3: num,
                    loc3Names: locNames
                  }, () => {
                    this.setData()
                  })
              }}
            />}
        >
          保育舍
        </List.Item>
        {
          loc3Names.map((o, index) => {
            return <InputItem
                maxLength={10}
                extra={'栋'}
                type={'text'}
                key={'loc3' + index}
                className={(tooltips[1].visible && index === 0 && farmType === 'PG')?'topShow w-10 no-border text-right': ' no-border text-right'}
                placeholder={o.locName}
                onChange={v => {
                  this.setState(state => {
                    state.loc3Names[index].locName = v;
                    state.loc3Names[index].name = '保育舍' + v + '栋';
                    return state
                  }, () => {
                    this.setData()
                  })
                }}
                   >
              栋舍名称({`${index + 1}`})
            </InputItem>
          })
        }
      </List>
      {/*育成4*/}
      <List renderHeader={() => ''}
          renderFooter={() => ''}
      >
        <List.Item
            extra={
            <Stepper
                className={'stepper-round'}
                style={{ width: '100%', minWidth: '100px' }}
                showNumber
                min={0}
                max={10}
                value={loc4}
                onChange={v => {
                  let num = parseInt(Number(v));
                  let locNames = new Array(num).fill('育成舍').map((o,index) => {
                    let currentName = `${index >= 9 ? index : ('0' + (index + 1))}`;
                    if (loc4Names[index]) {
                      let name = loc4Names[index].locName;
                      currentName = (currentName !== name) ? name : currentName
                    }
                    return {
                      houseName: o,
                      locName: currentName,
                      name:  o + currentName + '栋',
                      num: num,
                      batchNum: 1,
                      batchNames: [{
                        name: '001'
                      }]
                    }
                  });
                  this.setState({
                    loc4: num,
                    loc4Names: locNames
                  }, () => {
                    this.setData()
                  })
              }}
            />}
        >
          育成舍
        </List.Item>
        {
          loc4Names.map((o, index) => {
            return <InputItem
                key={'loc4' + index}
                extra={'栋'}
                maxLength={10}
                type={'text'}
                className={' no-border text-right'}
                placeholder={o.locName}
                onChange={v => {
                  this.setState(state => {
                    state.loc4Names[index].locName = v;
                    state.loc4Names[index].name = '育成舍' + v + '栋';
                    return state
                  }, () => {
                    this.setData()
                  })
                }}
                   >
              栋舍名称({`${index + 1}`})
            </InputItem>
          })
        }
      </List>

      <WingBlank size="lg">
        <Button type={'primary'}
            onClick={this.doSave}
        >完成</Button>
        <WhiteSpace size={'lg'}/>
      </WingBlank>

      <Mask visible={mask}>
        {
          this.state.tooltips.map((tips, index) => {
            return  <Bubble
                {...tips.position}
                showtips={'true'}
                visible={tips.visible.toString()}
                key={index}
                onClick={() => {
                      this.setState(state => {
                        state.tooltips[index].visible = false;
                        if (index < 1) {
                          state.tooltips[index + 1].visible = true
                        } else {
                          state.mask = false
                        }
                        return state;
                      })
              }}
                    >
                <div style={{height: index === 0 ? 160 : 180}}>
                  <div className={'line'}
                      style={{
                    transform: 'rotate(180deg)'
                  }}
                  />
                  {tips.message}
                </div>
            </Bubble>
          })
        }

      </Mask>
    </React.Fragment>
  )
 }
}
